const validator = (properties: Record<string, any>) => {
  const errors: string[] = [];

  if (!properties.credential) {
    errors.push('SMTP credential is required');
  }

  if (!properties.from) {
    errors.push('From email address is required');
  }

  if (!properties.to) {
    errors.push('Recipient email address is required');
  }

  if (!properties.subject) {
    errors.push('Email subject is required');
  }

  if (!properties.body) {
    errors.push('Email body is required');
  }

  // Basic email validation for 'from' field
  if (properties.from) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Only validate if it's not a variable interpolation
    if (!properties.from.includes('{{') && !emailRegex.test(properties.from.trim())) {
      errors.push(`Invalid from email address: ${properties.from}`);
    }
  }

  // Basic email validation for 'to' field
  if (properties.to) {
    const emails = properties.to.split(',').map((e: string) => e.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    for (const email of emails) {
      // Only validate if it's not a variable interpolation
      if (email && !email.includes('{{') && !emailRegex.test(email)) {
        errors.push(`Invalid email address: ${email}`);
      }
    }
  }

  return errors.length > 0 ? errors : null;
};

export default validator;
